import React from 'react';
import { locales } from '../../../translations/locales';
import { BsFire } from 'react-icons/bs';
import { MdOutlinePets, MdLocalPolice, MdPersonalInjury, MdFactory } from 'react-icons/md';
import { FaCarBurst, FaHelmetUn, FaBars, FaChevronRight } from 'react-icons/fa6';
import { GiMineExplosion } from 'react-icons/gi';
import { SiApachestorm } from 'react-icons/si';
import { TbUserSearch } from 'react-icons/tb';

const icons = {
    'ROAD_ACCIDENT': FaCarBurst,
    'HARM_PEOPLE': MdPersonalInjury,
    'HARM_ANIMALS_PROPERTY': MdOutlinePets,
    'FIRE': BsFire,
    'BLAST': GiMineExplosion,
    'OFFENSE': MdLocalPolice,
    'PUBLIC_ORDER': FaHelmetUn,
    'NATURAL_HAZARD': SiApachestorm,
    'TECHNOLOGICAL_HAZARD': MdFactory,
    'DISAPPEARANCES_DISCOVERIES': TbUserSearch,
    'OTHERS': FaBars,
};

const IconsCategories = (props) => {
    const { locale, icon, onChangeQualification, style, noText } = props;

    const Icon = icons[icon] ? icons[icon] : FaBars;

    return (
        <span
            className={`cursor-pointer`}
            onClick={() => onChangeQualification ? onChangeQualification({ target: { id: 'category', value: icon } }) : null}
        >
            <Icon
                className='mb-1 mr-2'
                style={{ height: style || '40px', width: style || '40px' }}
            />
            <span>
                {!noText ? locales[locale].sga[icon] : ''}
                {
                    !noText ? <FaChevronRight className='mb-1' /> : ''
                }
            </span>
        </span>
    );
};

export default IconsCategories;
